import { render, staticRenderFns } from "./GalleryHero.vue?vue&type=template&id=3d2bf237&scoped=true&"
import script from "./GalleryHero.vue?vue&type=script&lang=js&"
export * from "./GalleryHero.vue?vue&type=script&lang=js&"
import style0 from "./GalleryHero.vue?vue&type=style&index=0&id=3d2bf237&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2bf237",
  null
  
)

export default component.exports